import QuestionCard from "./QuestionCard";
export default QuestionCard;
